





































import { Component, Mixins, Prop } from 'vue-property-decorator';
import TextAreaField from '@/components/TextAreaField.vue';
import TextElement from '@/components/widgets/TextElement.vue';
import TextFieldElementMixin from '@/mixins/textFieldElementMixin';
import { SurveysService } from '@/services/surveys.service';
import { EventBus } from '@/event-bus';
import { WIDGET_EVENTS } from '@/const/widget-events';
import Stream from '@/helpers/stream';
import AppConfigMixin from '@/mixins/appConfigMixin';
import { ANALYTICS_ACTIONS } from '@/models/enums/analytics-actions.enum';

@Component({
  components: {
    TextAreaField,
    TextElement,
    AiErrorPrompt: () => import('@/components/AiErrorPrompt.vue'),
    Button: () => import('@/components/Button.vue'),
  },
})
export default class AIGeneratedTextAreaElement extends Mixins(
  TextFieldElementMixin,
  AppConfigMixin
) {
  $refs!: Vue['$refs'] & {
    textareaField: TextAreaField;
  };
  @Prop({ type: String, default: () => null }) regenerateButtonLabel!:
    | string
    | null;
  @Prop({ type: String, required: true }) question!: string;
  @Prop({ type: String, required: true }) label!: string;
  @Prop({ type: String, required: true }) name!: string;
  @Prop({ type: Number, required: true }) id!: number;

  private stream: Stream | null = null;
  private isGenerationCompleted: boolean = false;
  private isLoading: boolean = true;
  private generationLimit: number = 0;
  private isErrorPromptVisible: boolean = false;
  private get regenerateButtonLabelComputed() {
    return `${this.regenerateButtonLabel} (${this.$t('available')} ${
      this.generationLimit
    })`;
  }

  async created() {
    if (!this.value) {
      await this.generateAnswerHandler();
    }
  }

  private async setGenerationLimit() {
    this.isLoading = true;
    this.generationLimit = (
      await SurveysService.getChatGenerationsLimit(this.surveyId!)
    ).leftGenerationsNumber;
    this.isLoading = false;
  }

  private async generateAnswerHandler() {
    await this.sendSurveyAnalytics(
      ANALYTICS_ACTIONS.CLICKED_GENERATE_REVIEW,
      this.surveyId!
    );
    this.isErrorPromptVisible = false;
    this.isGenerationCompleted = false;
    if (this.stream) {
      this.stream.close();
      this.stream = null;
      this.$emit('change', null);
    }
    this.stream = new Stream(this.surveyId!, this.id);

    this.stream.connect();

    this.stream.onError(this.errorHandler);

    await this.stream
      ?.onMessage((message: string | null) => {
        this.scrollTextAreaWhileGenerating();
        EventBus.$emit(WIDGET_EVENTS.CHANGE, {
          field: this.field,
          value: message,
        });
      })
      .catch(this.errorHandler)
      .finally(async () => {
        await this.setGenerationLimit();
        this.isGenerationCompleted = true;
      });
  }

  private scrollTextAreaWhileGenerating() {
    const textareaEl = this.$refs.textareaField.$el.querySelector('textarea');
    if (textareaEl && textareaEl.scrollTop !== textareaEl.scrollHeight) {
      textareaEl.scrollTop = textareaEl.scrollHeight;
    }
  }

  private errorHandler() {
    this.isErrorPromptVisible = true;
    this.isGenerationCompleted = true;
    this.stream?.close();
    EventBus.$emit(WIDGET_EVENTS.CHANGE, { field: this.field, value: null });
  }

  private changeHandler(value: string) {
    EventBus.$emit(WIDGET_EVENTS.CHANGE, {
      field: this.field,
      value,
    });
  }

  private beforeDestroy() {
    this.stream?.close();
  }
}
